import script from "./CouponModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CouponModal.vue?vue&type=script&setup=true&lang=ts"

import "./CouponModal.vue?vue&type=style&index=0&id=151a93b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-151a93b2"]])

export default __exports__